<div class="header">
  <spb-logo [routePath]="['/', CUSTOMER_START]"
            title="Investeringsrådgivning"></spb-logo>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button/>
  @if (service.currentUser()) {
    <span>{{ service.currentUser()?.name }}</span>
    <button [style.margin-right.rem]="1" [matMenuTriggerFor]="menu"
            mat-icon-button>
      <mat-icon [style.margin-top.px]="1">menu</mat-icon>
    </button>
  }
</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="[CUSTOMER_PATH]" mat-menu-item>Kundhantering</button>
  <button
    [routerLink]="[MODEL_PORTFOLIO_PATH]" mat-menu-item>Modellportföljer
  </button>
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>
